export enum InformationBoxPosition {
	'TopLeft' = 'tl',
	'TopRight' = 'tr',
	'BottomLeft' = 'bl',
	'BottomRight' = 'br'
}
